
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/groups/jst/-autoLeadershipControls';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<fieldset class=\"pad-box auto-group-leader-controls\">\n  <span class=\"control-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.auto_leadership_controls")
  },data:data},helper ? helper.call(depth0, "groups.manage.auto_leadership_controls.leadership", "Leadership", options) : helperMissing.call(depth0, "t", "groups.manage.auto_leadership_controls.leadership", "Leadership", options)))
    + "</span>\n  <div class=\"controls\">\n    <label class=\"checkbox\" for=\"enable_auto_leader-";
  if (helper = helpers.uniqid) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqid); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'uniqid': (true),
    'class': ("auto-group-leader-toggle")
  },data:data},helper ? helper.call(depth0, "enable_auto_leader", options) : helperMissing.call(depth0, "checkbox", "enable_auto_leader", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.auto_leadership_controls")
  },data:data},helper ? helper.call(depth0, "groups.manage.auto_leadership_controls.auto_group_leader", "Automatically assign a student group leader", options) : helperMissing.call(depth0, "t", "groups.manage.auto_leadership_controls.auto_group_leader", "Automatically assign a student group leader", options)))
    + "\n    </label>\n  </div>\n  <div class=\"controls auto-group-leader-controls-radio\">\n    <label class=\"radio\">\n      <input type=\"radio\" name=\"auto_leader_type\" value=\"FIRST\" checked>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.auto_leadership_controls")
  },data:data},helper ? helper.call(depth0, "groups.manage.auto_leadership_controls.auto_first_group_leader", "Set first student to join as group leader", options) : helperMissing.call(depth0, "t", "groups.manage.auto_leadership_controls.auto_first_group_leader", "Set first student to join as group leader", options)))
    + "\n    </label>\n  </div>\n  <div class=\"controls auto-group-leader-controls-radio\">\n    <label class=\"radio\">\n      <input type=\"radio\" name=\"auto_leader_type\" value=\"RANDOM\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.auto_leadership_controls")
  },data:data},helper ? helper.call(depth0, "groups.manage.auto_leadership_controls.auto_random_group_leader", "Set a random student as group leader", options) : helperMissing.call(depth0, "t", "groups.manage.auto_leadership_controls.auto_random_group_leader", "Set a random student as group leader", options)))
    + "\n    </label>\n  </div>\n</fieldset>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/groups/jst/_autoLeadershipControls.handlebars', templates['/var/canvas/ui/shared/groups/jst/-autoLeadershipControls']);
    ;
    ;
    export default templates[name];
  